export default __webpack_public_path__ + "assets/jersey-flag.png";